<template>
<article class="person-detail">
  <router-link class="person-detail__link-back" to="/">
    &times;
  </router-link>
  <div class="person-detail__content">
    <div class="person-detail__image">
      <img
        :src="`./people/${person.image}`"
        :alt="fullName"
      />
    </div>
    <div class="person-detail__box">
      <h1 class="person-detail__fullname">
        {{fullName}}
      </h1>
      <h2 v-if="person.nee" class="person-detail__nee">rozená {{person.nee}}</h2>
      <span class="person-detail__meta">
        &lowast;&nbsp;{{birthDate}}
        {{birthPlace}}
        &nbsp;&ndash;&nbsp; &dagger;&nbsp;{{deathDate}}
        {{deathPlace}}
        <div class="person-detail__house-number">
          dům č.p.: {{person.house}}
        </div>
      </span>
      <div class="person-detail__info">
        <p>{{person.info}}</p>
      </div>
    </div>
  </div>
</article>
</template>

<script>
export default {
  props: {
    person: Object
  },
  created() {
    this.setTitle();
  },
  updated() {
    this.setTitle();
  },
  destroyed() {
    document.title = `Lidice.online - Projděte si osudy obyvatel Lidic`;
  },
  mounted() {
    this.$gtm.trackView("PersonDetail", "currentpath");
  },
  computed: {
    fullName() {
      return `${this.person.name} ${this.person.surname}`;
    },
    birthDate() {
      return parseInt(this.person.birthDate, 10);
    },
    deathDate() {
      return parseInt(this.person.deathDate, 10)
        ? parseInt(this.person.deathDate, 10)
        : "neznámé";
    },
    birthPlace() {
      return this.person.birthPlace ? `(${this.person.birthPlace})` : "";
    },
    deathPlace() {
      return this.person.deathPlace ? `(${this.person.deathPlace})` : "";
    }
  },
  methods: {
    setTitle() {
      document.title = `${
        this.fullName
      } / Lidice.online - Projděte si osudy obyvatel Lidic`;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.person-detail {
  position: fixed;
  background-color: var(--colorWhite);
  overflow: auto;
  border-right: 1px solid var(--colorBorder);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
  width: 100%;
  z-index: 2;
}

@media (min-width: 992px) {
  .person-detail {
    width: calc(100% - (100% / 1.618));
  }
}

.person-detail__link-back {
  display: block;
  font-size: 10rem;
  line-height: 0;
  position: absolute;
  right: 1rem;
  top: 2rem;
  text-decoration: none;
  color: var(--colorPrimary);
  transition: all 300ms ease-in-out;
  z-index: 1;
}

.person-detail__link-back:hover {
  opacity: 0.8;
}

.person-detail__image {
  width: 200px;
  border: 3px solid #aaaaaa;
  position: absolute;
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);
}

.person-detail__image img {
  max-width: 100%;
  vertical-align: top;
}

.person-detail__box {
  margin-top: 22rem;
}

.person-detail__fullname {
  font-size: 3rem;
  margin-bottom: 0.15em;
  margin-top: 0;
  letter-spacing: 0.018em;
  background-color: var(--colorPrimary);
  display: inline-block;
  line-height: 1.5;
  padding: 0 1rem;
  color: var(--colorWhite);
}

.person-detail__meta {
  display: block;
  margin-top: 0.5rem;
  font-weight: bold;
}

.person-detail__nee {
  margin-top: 0;
}

.person-detail__info {
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  line-height: 1.58;
  letter-spacing: -0.003em;
  white-space: pre-line;
  padding: 0 2rem;
  text-align: left;
}

.person-detail__house-number {
  display: inline-block;
  margin-left: 1rem;
}
</style>
